export default __webpack_public_path__ + "static/media/logo-expat-immo.d442c86a.png";